<mat-form-field>
  <mat-label>{{ 'common.productSearch' | translate }}</mat-label>
  <input [readonly]="isProductPicked" [class.readonly-disabled-look]="isProductPicked" [value]="pickedProductName"
    type="text" matInput name="searchProducts" #searchStock [matAutocomplete]="auto">

  <button type="button" [attr.aria-label]="'common.actions.clear' | translate" mat-icon-button matSuffix *ngIf="!loading" (click)="clearSelect()">
    <mat-icon>
      clear
    </mat-icon>
  </button>

  <div matSuffix class="p-1" *ngIf="loading">
    <mat-spinner diameter="40"></mat-spinner>
  </div>

  <mat-autocomplete (optionSelected)="selectProduct($event.option.value)" (closed)="hidePreview()"
    #auto="matAutocomplete">
    <mat-option *ngFor="let option of productResult" [value]="option">
      <div class="d-flex justify-content-between gap-2">
        <div class="d-flex">
          <img [alt]="(option | localizedName) || ('default image with id' + option.id)" [src]="option.imageName | appImageUrl"
            #trigger="cdkOverlayOrigin" cdkOverlayOrigin width="24" (error)="noImage(option)"
            (mouseover)="hoverProduct($event, option, trigger)" (mouseleave)="hidePreview()">
        </div>
        <div class="d-flex">
          {{option | localizedName}}
        </div>
      </div>
    </mat-option>

    <mat-option *ngIf="showNoResults" disabled class="no_results_opt_">
      <div class="no_results_box_">
        <mat-icon class="no_results_icon_">search_off</mat-icon>
        <span class="no_results_text_">{{ 'common.productSearchNoResults' | translate }}</span>
      </div>
    </mat-option>
  </mat-autocomplete>
</mat-form-field>

<!--
  Enlarged-image preview: ONE overlay owned by this component, deliberately declared OUTSIDE the
  option loop. Declared per-option it was destroyed by the very click that picks the product,
  which on WebKit left the pane attached with nothing able to close it (Safari fires no
  mouseout/mouseleave for a node removed under the pointer, unlike Blink).
  Do NOT move this back inside *ngFor.
-->
<ng-container *ngIf="previewOrigin as origin">
  <ng-container *ngIf="previewProduct as preview">
    <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="origin" [cdkConnectedOverlayOpen]="true">
      <div class="d-flex panel_onfire_ow justify-content-center flex-column align-items-center w-100">
        <div class="d-flex w-100">
          <img [src]="preview.imageName | appImageUrl" (error)="noImage(preview)"
            [alt]="(preview | localizedName) || ''" width="200">
        </div>
      </div>
    </ng-template>
  </ng-container>
</ng-container>